import Action from '../base/action';
import ActionFactory from "../base/action-factory";

class TextScript extends Action {
    script;

    constructor(props) {
        super(props);
        this.script = props.script;
        this.guiText = props.guiText;

    }

    async execute(eventLoop) {
        const textScript = eventLoop.training.textScript;
        const result = await textScript.run(this.script, {
            executeAction: eventLoop.executeAction.bind(eventLoop),
            createAction: ActionFactory.create.bind(ActionFactory),
            getModelNameFromID : eventLoop.getModelNameFromID.bind(eventLoop)
        });

        await eventLoop.training.updateEvaluation();

        return result;
    }
}

export default TextScript;
